import angular from 'angular'
import ComposeStepperComponent from './compose-stepper.component'

export default angular
  .module('composeStepper', [])
  .component('composeStepper', ComposeStepperComponent)
  .name
